// src/poker/table/helpers.js

export function rankPL(r) {
  const m = {
    A: "As",
    K: "Król",
    Q: "Dama",
    J: "Walet",
    T: "10",
    "9": "9",
    "8": "8",
    "7": "7",
    "6": "6",
    "5": "5",
    "4": "4",
    "3": "3",
    "2": "2",
  };
  return m[r] || r;
}

export function translateDescrPL(descr) {
  if (!descr) return "";
  let d = descr;

  d = d.replace(
    /^High Card,\s*(.+)\sHigh$/i,
    (_, r) => `Wysoka karta: ${rankPL(r.trim()[0].toUpperCase())}`
  );
  d = d.replace(/^Pair,\s*([2-9TJQKA])'s$/i, (_, r) => `Para: ${rankPL(r.toUpperCase())}`);
  d = d.replace(
    /^Two Pair,\s*([2-9TJQKA])'s\s*&\s*([2-9TJQKA])'s$/i,
    (_, a, b) => `Dwie pary: ${rankPL(a.toUpperCase())} i ${rankPL(b.toUpperCase())}`
  );
  d = d.replace(
    /^Three of a Kind,\s*([2-9TJQKA])'s$/i,
    (_, r) => `Trójka: ${rankPL(r.toUpperCase())}`
  );
  d = d.replace(
    /^Straight,\s*([2-9TJQKA])\sHigh$/i,
    (_, r) => `Strit: ${rankPL(r.toUpperCase())}-wysoki`
  );
  d = d.replace(
    /^Flush,\s*([2-9TJQKA])\sHigh$/i,
    (_, r) => `Kolor: ${rankPL(r.toUpperCase())}-wysoki`
  );
  d = d.replace(
    /^Full House,\s*([2-9TJQKA])'s\s*over\s*([2-9TJQKA])'s$/i,
    (_, a, b) => `Ful: ${rankPL(a.toUpperCase())} na ${rankPL(b.toUpperCase())}`
  );
  d = d.replace(
    /^Four of a Kind,\s*([2-9TJQKA])'s$/i,
    (_, r) => `Kareta: ${rankPL(r.toUpperCase())}`
  );
  d = d.replace(
    /^Straight Flush,\s*([2-9TJQKA])\sHigh$/i,
    (_, r) => `Poker: ${rankPL(r.toUpperCase())}-wysoki`
  );
  d = d.replace(/^Royal Flush$/i, () => `Poker królewski`);

  return d;
}

export function suitChar(s) {
  if (s === "S") return "♠";
  if (s === "H") return "♥";
  if (s === "D") return "♦";
  if (s === "C") return "♣";
  return s;
}

// ♥ czerwony, ♣ ciemnozielony, ♦ facebook-blue, ♠ fiolet
export function suitColor(s) {
  if (s === "H") return "var(--suit-heart)";
  if (s === "C") return "var(--suit-club)";
  if (s === "D") return "var(--suit-diamond)";
  if (s === "S") return "var(--suit-spade)";
  return "rgba(255,255,255,0.92)";
}

export function dealerStepLabelFromStreet(street) {
  if (street === "preflop") return "flopa";
  if (street === "flop") return "turna";
  if (street === "turn") return "rivera";
  if (street === "river") return "showdown";
  if (street === "showdown") return "zakończenia rozdania";
  return null;
}

export function humanizePokerErrorPL(code) {
  const c = String(code || "");
  const map = {
    tournament_complete: "Turniej zakończony — nie można rozpocząć kolejnego rozdania.",
    no_players_with_chips: "Brak graczy z żetonami — nie można rozpocząć kolejnego rozdania.",
    hand_not_complete: "Rozdanie nie jest zakończone.",
    only_dealer_can_start_next: "Tylko dealer może rozpocząć następne rozdanie.",
    only_dealer_can_advance: "Tylko dealer może wykładać karty.",
    cannot_advance_yet: "Nie można jeszcze przejść dalej — licytacja nie jest zamknięta.",

    forbidden_not_dealer: "Tylko dealer może to zrobić.",
    not_seated: "Nie siedzisz przy stole.",

    not_your_turn: "To nie Twoja tura.",
    not_in_hand: "Nie jesteś w rozdaniu.",
    raise_too_small: "Przebicie jest za małe.",
    bet_too_small: "Bet jest za mały.",
    bet_not_allowed: "Nie można betować — na stole jest już bet.",
    raise_not_allowed: "Nie można raise — na stole nie ma betu.",
    nothing_to_call: "Nie ma co wyrównać.",
    cannot_check: "Nie możesz checkować — musisz wyrównać.",

    room_not_found: "Pokój nie istnieje.",
    server_error: "Błąd serwera.",
  };

  return map[c] || c || "error";
}

export function formatStackBB(stack, bbAmount) {
  const s = Number(stack);
  const bb = Number(bbAmount);

  if (!Number.isFinite(s) || !Number.isFinite(bb) || bb <= 0) return "—";

  const raw = s / bb;

  // zaokrąglenie do 1 miejsca
  const rounded = Math.round(raw * 10) / 10;

  // jeśli po zaokrągleniu jest pełna liczba → bez .0
  if (Math.abs(rounded - Math.round(rounded)) < 0.0001) {
    return String(Math.round(rounded));
  }

  // zamiana kropki na przecinek
  return String(rounded).replace(".", ",");
}

// ===============================
// Amount formatting (chips vs BB) — one source of truth
// ===============================
export function formatAmount(value, stackViewMode = "chips", bbAmount = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";

  const bb = Number(bbAmount);
  if (stackViewMode === "bb" && Number.isFinite(bb) && bb > 0) {
    return `${formatStackBB(n, bb)} BB`;
  }
  // chips: pokazuj jako liczba (bez dopisywania "chips")
  return String(n);
}

// ===============================
// Last action formatting from object {type, amount}
// Supported types (backend): FOLD/CHECK/CALL/BET/RAISE/RAISE_TO
// ===============================
export function formatAction(lastAction, stackViewMode = "chips", bbAmount = 0) {
  if (!lastAction || !lastAction.type) return null;

  const t0 = String(lastAction.type).trim().toUpperCase();
  const t = t0 === "RAISE_TO" ? "RAISE" : t0;

  const amt = Number.isFinite(Number(lastAction.amount)) ? Number(lastAction.amount) : null;

  if (t === "FOLD") return "FOLD";
  if (t === "CHECK") return "CHECK";

  // CALL/BET/RAISE zwykle mają amount — ale fallback bez kwoty też ok
  if (amt == null) return t;
  return `${t} ${formatAmount(amt, stackViewMode, bbAmount)}`;
}

